/* eslint-disable promise/prefer-await-to-then */
import Compressor from 'compressorjs';

import processFileBlob from './processFileBlob';

export type ResizerOptions = {
  maxImageSize?: number;
  maxQuality?: number;
};
export const DEFAULT_MAX_IMAGE_SIZE = 2500;
export const DEFAULT_MAX_QUALITY = 0.7;

/**
 * Compresses an image with the provided parameters, and returns the base64 implementation
 *
 * @param image - The image file to compress
 * @param options - The options that will be provided to the compressor
 */
export const compressImage = (
  image: File,
  {
    maxImageSize = DEFAULT_MAX_IMAGE_SIZE,
    maxQuality = DEFAULT_MAX_QUALITY,
  }: ResizerOptions = {},
): Promise<string> =>
  // eslint-disable-next-line promise/avoid-new
  new Promise<string>((resolve, reject) => {
    try {
      // eslint-disable-next-line no-new
      new Compressor(image, {
        quality: maxQuality,
        maxWidth: maxImageSize,
        maxHeight: maxImageSize,
        mimeType: 'image/jpeg',
        success: (result: File) => {
          // eslint-disable-next-line no-void
          void processFileBlob(result)
            .then((processedFile) => resolve(processedFile.base64))
            .catch(reject);
        },
      });
    } catch (e) {
      reject(e instanceof Error ? e : new Error(String(e)));
    }
  });
